export default "__VITE_ASSET__DaJdUUa6__"